import React from 'react';
import { Col, Row } from 'antd';
import { TagsGroupBoxProps } from './TagProductsBox.types';
import { TagsContainer } from './TagProductsBox.styles';
import { BlueTitle } from '../../../styles/common.styles';

const TagProductsBox: React.FC<TagsGroupBoxProps> = ({ title = "", children }) => (
    <TagsContainer>
        {title && <Row>
            <Col span={24}>
                <BlueTitle>{title}</BlueTitle>
            </Col>
        </Row>}
        <Row>
            <Col span={24}>{children}</Col>
        </Row>
    </TagsContainer>
);

export default TagProductsBox;